import {FC, useCallback, useRef, useState} from 'react'
import {
  DndContext,
  rectIntersection,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
  type DragEndEvent,
  type DragStartEvent,
  DragOverlay,
  defaultDropAnimationSideEffects,
  MeasuringStrategy,
} from '@dnd-kit/core'
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  useSortable,
  rectSortingStrategy,
} from '@dnd-kit/sortable'
import {CSS} from '@dnd-kit/utilities'
import {InvoicePages} from '../../interfaces/Invoices'
import {v4 as uuidv4} from 'uuid'
import {Menu, MenuItem} from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import AddIcon from '@mui/icons-material/Add'
import DragIndicatorIcon from '@mui/icons-material/DragIndicator'
import {useIntl} from 'react-intl'
import Swal from 'sweetalert2'
import {Button} from 'react-bootstrap'
import Select from 'react-select'

interface InvoiceMultiInputImageProps {
  context: 'add' | 'update'
  multiPages: InvoicePages[] | null
  formik: any
  setMultiPages: React.Dispatch<React.SetStateAction<InvoicePages[] | null>>
}

export const InvoiceMultiInputImage: FC<InvoiceMultiInputImageProps> = ({
  context,
  multiPages,
  formik,
  setMultiPages,
}) => {
  const fileInputRefs = useRef<HTMLInputElement[]>([])

  const intl = useIntl()

  // ----------------------------------------------- DND -----------------------------------------------
  const [activeId, setActiveId] = useState<string | null>(null)

  // Find the active item
  const activeItem = activeId ? multiPages!.find((item) => item.id === activeId) : null

  // Set up sensors for drag detection with better sensitivity
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 8, // Minimum distance before a drag starts
      },
    }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  )

  // Handle drag start event
  function handleDragStart(event: DragStartEvent) {
    setActiveId(event.active.id as string)
  }

  // Handle drag end event
  function handleDragEnd(event: DragEndEvent) {
    const {active, over} = event
    setActiveId(null)

    if (over && active.id !== over.id) {
      setMultiPages((pages) => {
        if (!pages) return pages

        const oldIndex = pages.findIndex((page) => page.id === active.id)
        const newIndex = pages.findIndex((page) => page.id === over.id)

        const reshufflePages = arrayMove(pages, oldIndex, newIndex)

        return reshufflePages.map((page, index) => ({
          ...page,
          index,
          name: `Page-${index + 1}`,
        }))
      })
    }
  }

  // Custom drop animation
  const dropAnimation = {
    sideEffects: defaultDropAnimationSideEffects({
      styles: {
        active: {
          opacity: '0.5',
        },
      },
    }),
  }

  // ----------------------------------------------- DND -----------------------------------------------

  const addNewPage = () => {
    if (multiPages && multiPages.length === 8) return
    let id = uuidv4()
    const newPage: InvoicePages = {
      id,
      index: multiPages ? multiPages.length : 0,
      name: `Page-${multiPages ? multiPages.length + 1 : 1}`,
      templatePath: '',
      // paperSize: 'a4',
      fields: [],
    }
    setMultiPages((prevState) => (prevState ? [...prevState, newPage] : [newPage]))
    // formik.setFieldValue(
    // 	'backgroundImage',
    // 	[
    // 		...(formik.values.backgroundImage || []),
    // 		{ id, index: multiPages ? multiPages.length : 0, file: undefined, new:true }
    // 	]
    // )
  }

  return (
    <div>
      <div className='container p-0  gap-4'>
        <div className='row'>
          {/* <div
          style={{
            border: '1px solid #ccc',
          }}
          className='d-flex justify-content-between p-4 gap-4 bg-white rounded w-100 bg-light'
        >
          <div className='d-flex flex-column gap-2'>
            <small className='fw-bold'>Drag & Drop Text Items</small>
            <div className='d-flex flex-column gap-2'>
              <button
                // onClick={clearItems}
                type='button'
                className='d-flex items-center gap-2 btn btn-danger btn-sm'
              >
                {intl.formatMessage({id: 'FORM.LABEL.GENERAL_CLEAR'}, {title: 'Item'})}
              </button>
            </div>
          </div>
          <div className='d-flex flex-column gap-2'>
            <small className='fw-bold text-right'>
              {intl.formatMessage({id: 'FORM.LABEL.EDIT_PANEL'})}
            </small>
            <div className='d-flex justify-content-between'></div>
          </div>
        </div> */}
          <div className='col d-flex flex-column gap-4'>
            {/* <h1 className='form-label fs-6 fw-bolder text-dark'>
              {intl.formatMessage({id: 'INVOICE.PANEL.SET_PAGES'})}{' '}
            </h1> */}
            <label className='fw-bolder text-dark required'>
              {intl.formatMessage({id: 'FORM.ACTION.CHOOSE_IMAGE'})} <i>*Format PNG, JPG, JPEG</i>
            </label>
            <label className='fw-bolder text-dark required'>
              {intl.formatMessage({id: 'INVOICE.LABEL.IMAGE_INPUT_SIZE'}, {min:'(400 × 400)', max:'(2000 × 2000)'})}
            </label>
          </div>
          {/* <div className='col mb-4 gap-4'>
            <h1 className='form-label fs-6 fw-bolder text-dark'>
              {intl.formatMessage({id: 'INVOICE.LABEL.TYPE_FILE'})}{' '}
            </h1>
            <Select
              options={[
                {value: 'pdf', label: 'PDF'},
                {value: 'image', label: 'Image'},
              ]}
              placeholder={intl.formatMessage({id: 'INVOICE.LABEL.TYPE_FILE'})}
              value={
                formik.values.format === 'pdf'
                  ? { value: formik.values.format, label: 'PDF' }
                  : formik.values.format === 'image'
                  ? { value: formik.values.format, label: 'Image' }
                  : null
              }
              onChange={(option) => {
                formik.handleChange({
                  target: {
                    name: 'format',
                    value: option?.value || '',
                  },
                })
              }}
              className='w-100'
              onBlur={() => formik.values.format === '' && formik.setFieldTouched('format', true)}
              isMulti={false}
              // isReselectable={true}
            />
            {formik.touched.format && formik.errors.format && (
              <div className='fv-plugins-message-container text-danger'>
                <span role='alert' className='text-danger'>
                  {formik.errors.format}
                </span>
              </div>
            )}
          </div> */}
        </div>
      </div>
      <hr className='mb-4' />
      <DndContext
        sensors={sensors}
        collisionDetection={rectIntersection}
        onDragStart={handleDragStart}
        onDragEnd={handleDragEnd}
        measuring={{
          droppable: {
            strategy: MeasuringStrategy.Always,
          },
        }}
      >
        <SortableContext
          items={multiPages ? multiPages.map((item) => item.id) : []}
          strategy={rectSortingStrategy}
        >
          <div className='row row-cols-1 row-cols-md-2 row-cols-lg-4 g-4 mt-4'>
            {multiPages &&
              multiPages.length > 0 &&
              multiPages.map((page, index) => (
                <div key={page.id} className='col p-0'>
                  <SortableItem
                    key={page.id}
                    page={page}
                    setMultiPages={setMultiPages}
                    index={index}
                  />
                </div>
              ))}
            {multiPages && multiPages?.length < 4 && (context === 'add' || context === 'update') && (
              <div className='col p-0'>
                <div
                  className='bg-light d-flex align-items-center justify-content-center rounded border border-3 cursor-pointer'
                  style={{width: '260px', height: '260px'}}
                  onClick={() => {
                    addNewPage()
                  }}
                >
                  <AddIcon style={{fontSize: '60px'}} />
                </div>
              </div>
            )}
          </div>
        </SortableContext>

        {/* Drag Overlay - shows a preview of the dragged item */}
        <DragOverlay dropAnimation={dropAnimation}>
          {activeItem ? (
            <SortableItem
              key={activeItem.id}
              page={activeItem}
              setMultiPages={setMultiPages}
              index={activeItem.index}
            />
          ) : null}
        </DragOverlay>
      </DndContext>
      {formik.touched.backgroundImage && formik.errors.backgroundImage && (
        <div className='fv-plugins-message-container text-danger'>
          <span role='alert' className='text-danger'>
            {formik.errors.backgroundImage}
          </span>
        </div>
      )}
    </div>
  )
}

// Create a SortableItem component
const SortableItem = ({
  page,
  setMultiPages,
  index,
}: {
  page: InvoicePages
  setMultiPages: React.Dispatch<React.SetStateAction<InvoicePages[] | null>>
  index: number
}) => {
  const [openMenuId, setOpenMenuId] = useState<string | null>(null)

  const fileInputRefs = useRef<HTMLInputElement[]>([])

  const intl = useIntl()

  const handleImageUpload = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>, page: InvoicePages) => {
      if (event.target.files) {
        Array.from(event.target.files).forEach((file, index) => {
          const reader = new FileReader()
          reader.onload = (e) => {
            const img = new Image()
            img.onload = () => {
              const setImageFile = {
                imageFile: {
                  id: uuidv4(),
                  name: file.name,
                  width: img.width,
                  height: img.height,
                  size: file.size,
                  value: img.src,
                },
              }
              setMultiPages((prevState) => {
                if (prevState && prevState.length > 0) {
                  return prevState.map((item) =>
                    item.id === page.id ? {...item, ...setImageFile} : item
                  )
                } else {
                  return null
                }
              })
            }
            img.src = e.target?.result as string
          }
          reader.readAsDataURL(file)
        })
      }
    },
    []
  )

  const handleClick = (index: number) => {
    fileInputRefs.current[index]?.click()
  }

  const id = page.id
  const {attributes, listeners, setNodeRef, transform, transition, isDragging} = useSortable({id})

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.4 : 1,
  }

  return (
    <div
      ref={setNodeRef}
      className='position-relative bg-light d-flex flex-column align-items-center justify-content-center gap-4 rounded border border-3'
      style={{...style, width: '260px', height: '260px'}}
    >
      {page.imageFile && page.imageFile.value && (
        <div className='position-relative d-flex flex-column align-items-end justify-content-center'>
          <img
            src={page.imageFile.value}
            style={{width: '200px', height: '200px', objectFit: 'contain'}}
          />
          <div
            className='position-absolute bottom-0 text-center w-100 text-white'
            style={{
              backdropFilter: 'blur(2px)',
              backgroundColor: 'rgba(0,0,0,0.5)',
              padding: '2px',
            }}
          >
            <small
              style={{
                maxWidth: '100%',
                display: '-webkit-box',
                WebkitLineClamp: 1,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
              }}
            >
              {page.imageFile.name}
            </small>
          </div>
        </div>
      )}
      <div className='position-absolute cursor-pointer' style={{top: '5px', left: '0px'}}>
        <div
          aria-label={`more-${page.id}`}
          id={`menu-anchor-${page.id}`}
          onClick={() => {
            setOpenMenuId(page.id)
          }}
          className={`ms-2 bg-light`}
          style={{
            // background: '#fff',
            border: '1px solid #eee',
            borderRadius: '4px',
          }}
        >
          <MoreVertIcon />
        </div>
        <Menu
          id={`menu-${page.id}`}
          anchorEl={document.getElementById(`menu-anchor-${page.id}`)}
          open={openMenuId === page.id}
          onClose={() => setOpenMenuId(null)}
          disableScrollLock={true}
        >
          <MenuItem
            onClick={() => {
              if (page.fields.length === 0) {
                setOpenMenuId(null)
                return setMultiPages((prevItems) =>
                  prevItems ? prevItems.filter((item) => item.id !== page.id) : null
                )
              }
              setOpenMenuId(null)
              Swal.fire({
                title: intl.formatMessage({id: 'ALERT.TITLE.WARNING'}),
                text: intl.formatMessage(
                  {id: 'INVOICE.PAGE.DELETE'},
                  {title: `Page-${page.index + 1}`}
                ), //page.name
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: intl.formatMessage({id: 'FORM.VALIDATION.CONFIRMATION'}),
                cancelButtonText: intl.formatMessage({id: 'FORM.VALIDATION.CANCEL'}),
              }).then(async (result) => {
                if (result.isConfirmed) {
                  setMultiPages((prevItems) =>
                    prevItems
                      ? prevItems
                          .filter((item) => item.id !== page.id)
                          .map((item, index) => ({...item, index, name: `Page-${index + 1}`}))
                      : null
                  )
                }
              })
              // formik.setFieldValue(`backgroundImage.${page.index}`, undefined)
              // formik.setFieldValue(
              // 	'backgroundImage',
              // 	formik.values.backgroundImage?.filter((item:any) => item.id !== page.id)
              // )
            }}
          >
            <i className='fas fa-trash fs-3 me-5'></i>
            <span>{intl.formatMessage({id: 'FORM.ACTION.DELETE'})}</span>
          </MenuItem>
        </Menu>
      </div>
      <div
        {...attributes}
        {...listeners}
        className='position-absolute p-2 rounded'
        style={{cursor: 'grab', top: '-2px', right: '-2px'}}
      >
        <DragIndicatorIcon style={{height: '20px', width: '20px', color: '#ccc'}} />
      </div>
      <button
        type='button'
        onClick={() => handleClick(index)}
        className=''
        style={{
          padding: '3px 6px',
          // background: '#ffe'
          border: '1px solid #ccc',
          borderRadius: '8px',
        }}
      >
        {intl.formatMessage({id: 'INVOICE.INPUT.FILE_PAGE'}, {title: `Page-${index + 1}`})}
      </button>
      <input
        type='file'
        name='backgroundImage'
        accept='.jpg, .jpeg, .png'
        ref={(el) => {
          if (el) fileInputRefs.current[index] = el
        }}
        // multiple
        onChange={(e: any) => {
          // formik.setFieldValue(
          // 	'backgroundImage',
          // 	formik.values.backgroundImage?.filter((item:any) => item.id !== page.id)
          // )
          const files = e.target.files
          // console.log('files',files, files.length)
          if (!files || files.length === 0 || files === undefined) return
          // const setBackgroundImageValue = formik.values.backgroundImage.map((item:any) => {
          // 	if (item.id === page.id) {
          // 		return {
          // 			...item,
          // 			id: page.id, index: index, file: files[0]}
          // 	}
          // 	return item
          // })
          // formik.setFieldValue('backgroundImage', setBackgroundImageValue)
          handleImageUpload(e, page)
        }}
        className='visually-hidden'
      />
    </div>
    // <div
    // className='col p-0'
    // >
    // </div>
  )
}
